'use strict';

var React = require('react');
require('prop-types');
var index = require('../../node_modules/react-lines-ellipsis/lib/index.js');
var EditAndDelete = require('../EditAndDelete.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  verticalTextLayout: {
    marginTop: 'auto',
    marginBottom: 'auto'
  },
  testimonialText: {
    fontSize: 18,
    fontWeight: 400,
    fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif'
  }
};

function TestimonialQuoteOnly(_ref) {
  var classes = _ref.classes,
      testimonial = _ref.testimonial,
      _onEditClick = _ref.onEditClick,
      _onDeleteClick = _ref.onDeleteClick,
      canEdit = _ref.canEdit,
      canDelete = _ref.canDelete;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: true,
    className: classes.verticalTextLayout
  }, React__default["default"].createElement(index, {
    className: classes.testimonialText,
    text: testimonial.quote,
    maxLine: 1,
    ellipsis: "...",
    basedOn: "words"
  })), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(EditAndDelete, {
    onEditClick: function onEditClick() {
      return _onEditClick();
    },
    onDeleteClick: function onDeleteClick() {
      return _onDeleteClick();
    },
    canEdit: canEdit,
    canDelete: canDelete
  })))));
}

TestimonialQuoteOnly.defaultProps = {
  onEditClick: function onEditClick() {},
  onDeleteClick: function onDeleteClick() {}
};
var TestimonialQuoteOnly$1 = withStyles(styles)(TestimonialQuoteOnly);

module.exports = TestimonialQuoteOnly$1;
